import React, { useState, useEffect } from "react";
import styles from "./UsersAllTab.module.css";
import InfoCard from "DreamStream/Shared/InfoCard";
import SearchBar from "DreamStream/Shared/SearchBar";
import Button from "shared/Button";
import { FaFilter } from "react-icons/fa";
import UsersList from "./UsersList";
import Card from "shared/Card";
import ConfirmationModal from "DreamStream/Shared/ConfirmationModal";
import CreateNewAccountModal from "./CreateNewAccountModal";
import FilterMenu from "DreamStream/Shared/FilterMenu";
import { useUsersData } from "../useUsersData";

// const users = [
//   {
//     dsID: "0000000000",
//     iboNum: "0000000000",
//     name: "Dreamstream Name",
//     pin: "Diamond",
//     status: true,
//   },

//   {
//     dsID: "0000000000",
//     iboNum: "0000000000",
//     name: "Me",
//     pin: "Diamond",
//     status: true,
//   },
// ];

const userInfo = {
  name: "Name  here",
  iboNum: "IBO#  here",
  wwgEmail: "Email here",
};

const groups = [
  { groupName: "Link Status", groupItems: ["Linked", "Not Linked"] },
];

/**
 * Content in all users page.
 */

export function UsersAllTab() {
  const [runSyncModalOpen, setRunSyncModalOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const { data, status, refetch } = useUsersData("users");

  const [usersData, setUsersData] = useState([]);

  useEffect(() => {
    if (status === "success") {
      setUsersData(data);
    }
  }, [data, status, refetch]);

  const [searchInput, setSearchInput] = useState("");

  //Temporary filtering
  // const keys = ["iboNum", "name", "pin", "status"];

  // const search = (data) => {
  //   return data.filter((item) =>
  //     keys.some(
  //       (key) =>
  //         typeof item[key] === "string" &&
  //         item[key].toLowerCase().includes(searchInput)
  //     )
  //   );
  // };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.infoCardContainer}>
          <InfoCard
            body=""
            btnName="CREATE"
            footer=""
            header="CREATE NEW DREAMSTREAM ACCOUNT"
            onClick={() => {
              setCreateModalOpen(true);
            }}
          />

          <InfoCard
            body="10/18/2022 12:01 AM"
            btnName="SYNC"
            footer="Next Sync: 11/18/2022 12:01 AM"
            header="TIME OF LAST GLOBAL SYNC"
            onClick={() => {
              setRunSyncModalOpen(true);
            }}
          />
        </div>

        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>USERS</h5>
            <div className={styles.hr} />
          </div>
          <div className={styles.searchBarDiv}>
            <div className={styles.searchBar}>
              <SearchBar
                btn={true}
                searchDelay={0}
                minChar={0}
                // onInput={(value) => filterList(value)}
                onInput={(value) => setSearchInput(value)}
                placeholderText="Search by IBO Name, IBO #, DreamstreamID#, or email"
              />
            </div>
            <div className={styles.filterDiv}>
              <Button
                className={styles.filter}
                icon={<FaFilter />}
                onClick={() => {
                  setFilterModalOpen(true);
                }}
              >
                FILTER
              </Button>
            </div>
          </div>

          <div className={styles.usersDiv}>
            {status === "success" ? (
              <>
                <UsersList users={usersData} />
              </>
            ) : status === "loading" ? (
              <div className={styles.loadMessage}>Loading data...</div>
            ) : (
              <div className={styles.loadMessage}>Error fetching data</div>
            )}
          </div>
        </Card>

        <ConfirmationModal
          header="RUN GLOBAL SYNC"
          isOpen={runSyncModalOpen}
          description="Sync every user in the Dreamstream database. The last global sync was run [MM/DD/YYYY at HH:MM AM]."
          btnName="RUN SYNC"
          onClose={() => setRunSyncModalOpen(false)}
          onClick={() => alert("Run Sync clicked")}
          className={styles.modalOverlay}
        />

        <CreateNewAccountModal
          isOpen={createModalOpen}
          userInfo={usersData}
          onClose={() => setCreateModalOpen(false)}
        />

        <FilterMenu
          isOpen={filterModalOpen}
          onCollapse={() => setFilterModalOpen(false)}
          onClick={() => alert("Filter clicked")}
          groups={groups}
        />
      </div>
    </>
  );
}
